import React, { useState, useEffect } from 'react';
import ConfirmModal from './ConfirmModal';
import AlertModal from './AlertModal';
import { getModalService } from '../utils/ModalService';

export const GlobalModal = () => {
  const [confirmOptions, setConfirmOptions] = useState<any>(null);
  const [alertOptions, setAlertOptions] = useState<any>(null);

  useEffect(() => {
    const service = getModalService();
    service.setHandlers(
      (options: any) => setConfirmOptions(options),
      (options: any) => setAlertOptions(options)
    );
  }, []);

  return (
    <>
      {confirmOptions && (
        <ConfirmModal
          isOpen={true}
          title={confirmOptions.title}
          message={confirmOptions.message}
          onConfirm={() => {
            confirmOptions.onConfirm();
            setConfirmOptions(null);
          }}
          onCancel={() => {
            if (confirmOptions.onCancel) confirmOptions.onCancel();
            setConfirmOptions(null);
          }}
        />
      )}
      {alertOptions && (
        <AlertModal
          isOpen={true}
          title={alertOptions.title}
          message={alertOptions.message}
          onClose={() => {
            if (alertOptions.onClose) alertOptions.onClose();
            setAlertOptions(null);
          }}
        />
      )}
    </>
  );
};
